"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.minified = void 0;
var minified = function () {
    var isDebug = window.hasOwnProperty('URLSearchParams') && new URLSearchParams().has('debug');
    return isDebug ? '' : '.min';
};
exports.minified = minified;
//# sourceMappingURL=minified.js.map